import { render, staticRenderFns } from "./process-datasource-form.vue?vue&type=template&id=ecb1a922"
import script from "./process-datasource-form.vue?vue&type=script&lang=js"
export * from "./process-datasource-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports